(() => {
  if (window.__msR17Video) return;
  window.__msR17Video = true;

  /* ════════════════════════════════════════════════════════════════════════
     R17 · Video runtime
     ════════════════════════════════════════════════════════════════════════
     This exists for one reason: to own the play() promise.

     Dawn's DeferredMedia does this on click:

         if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
           deferredElement.play();
         }

     -- no catch. play() rejects for reasons that have nothing to do with bugs:
     iOS Low Power Mode refuses playback outright, and any un-muted start can be
     refused by autoplay policy. An uncaught rejection there gives you a console
     error and a video sitting on its first frame with no explanation.

     So ms-video.liquid deliberately omits the autoplay attribute. Dawn then
     inserts the element and stops, and everything below is ours: we start
     playback, we catch the refusal, and we say so on the frame instead of
     leaving it looking broken. The video already carries native controls, so
     the recovery path is always available.

     Event delegation on document, not per-element binding -- new sections
     arriving from the theme editor need no rebinding, and there is nothing to
     leak.
     ════════════════════════════════════════════════════════════════════════ */

  const HINT = 'Press play to start';

  const showBlocked = (media) => {
    if (media.hasAttribute('data-ms-play-blocked')) return;
    media.setAttribute('data-ms-play-blocked', '');
    const hint = document.createElement('span');
    hint.className = 'ms-video__hint';
    hint.textContent = HINT;
    media.appendChild(hint);
  };

  const clearBlocked = (media) => {
    media.removeAttribute('data-ms-play-blocked');
    const hint = media.querySelector('.ms-video__hint');
    if (hint) hint.remove();
  };

  const start = (media) => {
    const video = media.querySelector('video');
    if (!video) return false;

    // Dawn calls pauseAllMedia() before inserting, which pauses every <video>
    // on the page. Nothing here ever restarts a video it did not start, so the
    // "observer restarts what pauseAllMedia just paused" fight cannot happen.
    const played = video.play();
    if (played && typeof played.then === 'function') {
      played.then(() => clearBlocked(media)).catch(() => showBlocked(media));
    }
    return true;
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const poster = target.closest('.ms-video__poster');
    if (!poster) return;

    const media = poster.closest('.ms-video__media');
    if (!media) return;

    // Dawn's handler is bound to the poster itself, so by the time this
    // document-level listener runs during the same bubble the <video> is
    // already in the DOM. The timeout is only for the case where that order
    // ever changes -- it costs nothing and turns a silent failure into a
    // one-frame delay.
    if (!start(media)) setTimeout(() => start(media), 0);
  });
})();
